<div class="page-container">
  <div class="main-page-title flex-c">
    <span
      class="font-regular-display-small"
      [innerHTML]="inputData.title"></span>
    <span
      class="font-bold-headline-small"
      [innerHTML]="inputData.description"></span>
  </div>
  <div class="main-content">
    <div class="wip">
      <div class="wip-icon">
        <i class="fa-light fa-newspaper"></i>
      </div>
      <div class="wip-textcontent">
        <span
          class="wip-textcontent-title"
          [innerHTML]="inputData.textcontentTitle">
        </span>
        <span
          class="wip-textcontent-description"
          [innerHTML]="inputData.textcontentDescription">
        </span>
      </div>
      <button
        type="button"
        class="wip-button"
        href="mailto:institut@wissen.de?subject=HomepageFeedback">
        <!--(click)="giveFeedback()" -->
        <i class="inwi-button-icon-sm fa-light fa-message-question"></i>
        <span class="inwi-button-text">Feedback / Support</span>
      </button>
    </div>
  </div>
</div>
